<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/200kW/200kW.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">200kW 多合一电驱总成</div>
                <div class="detail-banner-desc transmission">Motor+MCU+VCU+GearBox+OBC+DCDC+PDU 多合一电驱总成
                    <div class="detail-desc">
                        <div>
                            高度集成了MCU、DCDC、OBC、VCU、EOP、断开、差速锁等控制器：兼容中性点升压功能；<br />
                        </div>
                        <div>
                            兼容400V和800V电压平台；<br />
                        </div>
                        <div>
                            所有轴承均采用球轴承提升效率；<br />
                        </div>
                        <div>
                            电机/减速器/控制器一体壳设计，降低高度尺寸。
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="one-titile">
                    电压平台：210~470V
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/200kW/200kW-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">6.6kW</div>
                                    <div class="k">OBC功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3kW</div>
                                    <div class="k">DCDC功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">200kW</div>
                                    <div class="k">峰值功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">22000rpm</div>
                                    <div class="k">最高工作转速</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3500N·m</div>
                                    <div class="k">峰值输出扭矩</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">88kg</div>
                                    <div class="k">重量</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">90.5%</div>
                                    <div class="k">WLTC效率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">油冷</div>
                                    <div class="k">冷却方式</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    电压平台：340V~900V
                </div>
                <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">6.6kW/11kW</div>
                                    <div class="k">OBC功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3kW</div>
                                    <div class="k">DCDC功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">270kW</div>
                                    <div class="k">峰值功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">22000rpm</div>
                                    <div class="k">最高工作转速</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">4500N·m</div>
                                    <div class="k">峰值输出扭矩</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">92kg</div>
                                    <div class="k">重量</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">92.7%</div>
                                    <div class="k">WLTC效率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">油冷</div>
                                    <div class="k">冷却方式</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/200kW/200kW-2.jpg" alt="200-1-02">
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '200kW 多合一电驱总成 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'transmission/200.html'
};

import { createApp } from 'vue';
import App from './200.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./200.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
